import Modal, { useModalState } from "Components/Atoms/Modal";
import PrimaryButton from "Components/Atoms/button/PrimaryButton";

function WelcomeModal() {
  const [isOpen, setOpen] = useModalState({ isOpen: true });

  return (
    <Modal
      title="Welcome back!"
      isOpen={isOpen}
      content={
        <>
          <div className="flex flex-col gap-2">
            <p>
              You entered Entries using a new link. Hang on while the
              organization that owns the subscription link verifies your
              account. You will be informed by email when this is done.
            </p>
            <p>
              Meanwhile, you may browse the services you already have access to.
            </p>
          </div>
        </>
      }
      controls={
        <PrimaryButton onClick={() => setOpen(false)}>Continue</PrimaryButton>
      }
      closeOnOutsideClick={false}
    />
  );
}

export default WelcomeModal;
